import { z } from "zod";

export const usuarioClienteSchema = z.object({
  nome: z.string().min(3, "Nome é obrigatório"),
  email: z.string().email("E-mail inválido"),
  senha: z.string().min(6, "A senha deve conter pelo menos 6 caracteres"),
  documento: z
    .string()
    .trim()
    .optional()
    .refine(
      (value) => {
        if (!value) return true; // não informou → ok
        return value.length >= 11 && value.length <= 18;
      },
      {
        message: "Documento inválido",
      }
    ),
});
